<aside
  class="premium-sidebar"
  [class.sidebar-open]="isOpen"
  [class.sidebar-closed]="!isOpen"
  [class.collapsed]="isCollapsed">
  
  <!-- Sidebar Header -->
  <div class="sidebar-brand">
    <div class="brand-logo-circle">
      <img src="assets/odisha-logo.png" alt="Odisha Logo">
    </div>
    <div class="brand-info">
      <span class="brand-name">PPMS Dashboard</span>
      <span class="brand-sub">Govt of Odisha</span>
    </div>
  </div>

  <nav class="sidebar-nav custom-scroll">
    <!-- Home link — only for Minister & OSD (operators/approvers/admins land on their consoles) -->
    <a *ngIf="isMinister() || isOsd()"
       routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
       class="nav-item" (click)="onLinkClick()" title="Home">
      <i class="fa-solid fa-house"></i> <span class="nav-label">Home</span>
    </a>

    <!-- OPERATOR SECTION — single-screen workflow, no per-department drill-in -->
    <ng-container *ngIf="isOperator() && !isMinisterOrOsd()">
      <div class="nav-divider"></div>
      <a routerLink="/dhamnagar-dashboard/operator" routerLinkActive="active" class="nav-item" (click)="onLinkClick()" title="Operator Console">
        <i class="fa-solid fa-desktop"></i> <span class="nav-label">Operator Console</span>
      </a>
      <a class="nav-item" (click)="triggerAction('/dhamnagar-dashboard/operator', 'new-request')" title="New Project Request">
        <i class="fa-solid fa-plus"></i> <span class="nav-label">New Project Request</span>
      </a>
      <a class="nav-item" (click)="triggerAction('/dhamnagar-dashboard/operator', 'import')" title="Import Projects">
        <i class="fa-solid fa-file-import"></i> <span class="nav-label">Import Projects</span>
      </a>
    </ng-container>

    <!-- APPROVER SECTION — single-screen workflow, no per-department drill-in -->
    <ng-container *ngIf="isApprover() && !isMinisterOrOsd()">
      <div class="nav-divider"></div>
      <a routerLink="/dhamnagar-dashboard/approver" routerLinkActive="active" class="nav-item" (click)="onLinkClick()" title="Approver Console">
        <i class="fa-solid fa-clipboard-check"></i> <span class="nav-label">Approver Console</span>
      </a>
    </ng-container>

    <!-- ADMINISTRATION (ADMIN ONLY) -->
    <ng-container *ngIf="isAdmin() && !isMinisterOrOsd()">
      <a routerLink="/dhamnagar-dashboard/user-management" routerLinkActive="active" class="nav-item" (click)="onLinkClick()" title="User Management">
        <i class="fa-solid fa-users-gear"></i> <span class="nav-label">User Management</span>
      </a>
    </ng-container>

    <!-- OSD ACCESS (SUPER DASHBOARD) -->
    <ng-container *ngIf="isMinisterOrOsd()">
      <a routerLink="/dhamnagar-dashboard/dashboard" routerLinkActive="active" class="nav-item" (click)="onLinkClick()" title="HM Decision Dashboard">
        <i class="fa-solid fa-chart-line"></i> <span class="nav-label">HM Decision Dashboard</span>
      </a>
      <a routerLink="/dhamnagar-dashboard/priorities" routerLinkActive="active" class="nav-item" (click)="onLinkClick()" title="HM Priorities">
        <i class="fa-solid fa-star"></i> <span class="nav-label">HM Priorities</span>
      </a>
      <a routerLink="/dhamnagar-dashboard/intervention" routerLinkActive="active" class="nav-item" (click)="onLinkClick()" title="Projects Requiring Intervention">
        <i class="fa-solid fa-flag"></i> <span class="nav-label">Projects Requiring Intervention</span>
      </a>

      <div class="nav-divider"></div>

      <a class="nav-item" (click)="openPanel('reports')" title="Reports">
        <i class="fa-regular fa-file-lines"></i> <span class="nav-label">Reports</span>
        @if (reportRows().length > 0) { <span class="nav-badge soft">{{ reportRows().length }}</span> }
      </a>
      <a class="nav-item" (click)="openPanel('analytics')" title="Analytics">
        <i class="fa-solid fa-chart-column"></i> <span class="nav-label">Analytics</span>
      </a>
      <a class="nav-item" (click)="openPanel('documents')" title="Documents">
        <i class="fa-regular fa-folder-open"></i> <span class="nav-label">Documents</span>
        @if (documentsRows().length > 0) { <span class="nav-badge soft">{{ documentsRows().length }}</span> }
      </a>
      <a class="nav-item" (click)="openPanel('alerts')" title="Alerts & Notifications">
        <i class="fa-regular fa-bell"></i> <span class="nav-label">Alerts &amp; Notifications</span>
        @if (alertCount() > 0) { <span class="nav-badge danger">{{ alertCount() }}</span> }
      </a>
      <a class="nav-item" (click)="openPanel('settings')" title="Settings">
        <i class="fa-solid fa-gear"></i> <span class="nav-label">Settings</span>
      </a>
    </ng-container>
  </nav>

  <!-- QUICK HELP CARD (OSD only) -->
  @if (isMinisterOrOsd()) {
    <div class="quick-help-card" (click)="openPanel('help')">
      <div class="qh-icon"><i class="fa-solid fa-headset"></i></div>
      <div class="qh-meta">
        <span class="qh-title">Quick Help</span>
        <span class="qh-sub">Need assistance?</span>
        <span class="qh-action">Contact Support <i class="fa-solid fa-arrow-right"></i></span>
      </div>
    </div>
  }

  <div class="sidebar-footer">
    <div class="user-profile-mini" *ngIf="currentUser()">
      <div class="mini-avatar" [class.mini-avatar-photo]="!!profileUi.avatarUrl(currentUser())">
        @if (profileUi.avatarUrl(currentUser()); as photo) {
          <img [src]="photo" alt="" />
        } @else {
          {{ profileUi.avatarInitial(currentUser()) }}
        }
      </div>
      <div class="mini-info">
        <span class="mini-name">{{ profileUi.displayName(currentUser()) }}</span>
        <span class="mini-role admin-role">{{ profileUi.roleBadge(currentUser()) }}</span>
      </div>
    </div>
  </div>

</aside>

<!-- Panel modal outside sidebar — avoids mobile transform clipping -->
@if (activePanel()) {
  <div class="sb-panel-overlay" (click)="closePanel()">
    <div class="sb-panel-card" (click)="$event.stopPropagation()">
      <div class="sb-panel-header">
        <h3>{{ panelTitle() }}</h3>
        <button class="sb-panel-close" (click)="closePanel()" aria-label="Close"><i class="fa-solid fa-xmark"></i></button>
      </div>

      <div class="sb-panel-body">
        @switch (activePanel()) {
          @case ('reports') {
            <div class="sb-row-actions">
              <button class="sb-btn-primary" (click)="exportReportCsv()">
                <i class="fa-solid fa-download"></i> Export CSV
              </button>
              <span class="sb-meta-text">{{ reportRows().length }} project(s) • Live from Firestore</span>
            </div>
            @if (reportRows().length === 0) {
              <div class="sb-empty"><i class="fa-solid fa-circle-info"></i><p>No projects yet.</p></div>
            } @else {
              <table class="sb-table sb-panel-desktop">
                <thead>
                  <tr><th>Project</th><th>Dept</th><th>Status</th><th class="text-center">Progress</th><th class="text-right">Cost (₹L)</th></tr>
                </thead>
                <tbody>
                  @for (p of reportRows(); track p.id) {
                    <tr>
                      <td>{{ p.name }}</td>
                      <td>{{ p.dept }}</td>
                      <td><span class="sb-pill" [class.stuck]="p.status==='Stuck'" [class.completed]="p.status==='Completed'" [class.inprogress]="p.status==='In Progress'">{{ p.status }}</span></td>
                      <td class="text-center">{{ p.physical || 0 }}%</td>
                      <td class="text-right">{{ p.cost | number }}</td>
                    </tr>
                  }
                </tbody>
              </table>
              <div class="sb-mobile-cards">
                @for (p of reportRows(); track p.id) {
                  <div class="sb-m-card">
                    <div class="sb-m-card-title">{{ p.name }}</div>
                    <div class="sb-m-card-row">
                      <span class="sb-m-card-dept">{{ p.dept }}</span>
                      <span class="sb-pill" [class.stuck]="p.status==='Stuck'" [class.completed]="p.status==='Completed'" [class.inprogress]="p.status==='In Progress'">{{ p.status }}</span>
                    </div>
                    <div class="sb-m-card-foot">
                      <span><i class="fa-solid fa-chart-line"></i> {{ p.physical || 0 }}%</span>
                      <span><i class="fa-solid fa-indian-rupee-sign"></i> {{ p.cost | number }} L</span>
                    </div>
                  </div>
                }
              </div>
            }
          }

          @case ('analytics') {
            <div class="sb-kpi-grid">
              <div class="sb-kpi"><span class="lbl">Total Projects</span><span class="val">{{ analyticsStats().total | number }}</span></div>
              <div class="sb-kpi"><span class="lbl">Sanctioned</span><span class="val">₹{{ (analyticsStats().sanctioned / 10000000) | number:'1.0-2' }} Cr</span></div>
              <div class="sb-kpi"><span class="lbl">Spent</span><span class="val">₹{{ (analyticsStats().spent / 10000000) | number:'1.0-2' }} Cr</span></div>
              <div class="sb-kpi"><span class="lbl">Avg. Progress</span><span class="val">{{ analyticsStats().avgProgress }}%</span></div>
            </div>
            <div class="sb-status-grid">
              <div class="sb-stat-bar completed"><span>Completed</span><strong>{{ analyticsStats().completed }}</strong></div>
              <div class="sb-stat-bar inprogress"><span>In Progress</span><strong>{{ analyticsStats().inProgress }}</strong></div>
              <div class="sb-stat-bar stuck"><span>Stuck / Delayed</span><strong>{{ analyticsStats().stuck }}</strong></div>
              <div class="sb-stat-bar planned"><span>Planned</span><strong>{{ analyticsStats().planned }}</strong></div>
            </div>
          }

          @case ('documents') {
            @if (documentsRows().length === 0) {
              <div class="sb-empty"><i class="fa-regular fa-folder-open"></i><p>No project documents uploaded yet.</p></div>
            } @else {
              <table class="sb-table sb-panel-desktop">
                <thead>
                  <tr><th>Project</th><th>Dept</th><th class="text-center">Photos</th><th>Last Upload</th></tr>
                </thead>
                <tbody>
                  @for (p of documentsRows(); track p.id) {
                    <tr>
                      <td>{{ p.name }}</td>
                      <td>{{ p.dept }}</td>
                      <td class="text-center">{{ (p.photos?.length ?? 0) + (p.beforeImageUrl ? 1 : 0) + (p.currentImageUrl ? 1 : 0) }}</td>
                      <td>{{ p.photoUploadedAt ? (p.photoUploadedAt | date:'mediumDate') : '–' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
              <div class="sb-mobile-cards">
                @for (p of documentsRows(); track p.id) {
                  <div class="sb-m-card">
                    <div class="sb-m-card-title">{{ p.name }}</div>
                    <div class="sb-m-card-row">
                      <span class="sb-m-card-dept">{{ p.dept }}</span>
                      <span class="sb-m-card-badge">
                        <i class="fa-regular fa-image"></i>
                        {{ (p.photos?.length ?? 0) + (p.beforeImageUrl ? 1 : 0) + (p.currentImageUrl ? 1 : 0) }} photos
                      </span>
                    </div>
                    <div class="sb-m-card-foot">
                      <span><i class="fa-regular fa-clock"></i> {{ p.photoUploadedAt ? (p.photoUploadedAt | date:'mediumDate') : 'No upload' }}</span>
                    </div>
                  </div>
                }
              </div>
            }
          }

          @case ('alerts') {
            <div class="sb-alert-section">
              <h4><i class="fa-solid fa-circle-exclamation text-red-600"></i> Stuck / Delayed Projects ({{ alertItems().delayed.length }})</h4>
              @if (alertItems().delayed.length === 0) {
                <p class="sb-muted">None.</p>
              } @else {
                @for (p of alertItems().delayed; track p.id) {
                  <div class="sb-alert-row">
                    <span class="sb-dot red"></span>
                    <span>{{ p.name }} <small>({{ p.dept }})</small></span>
                  </div>
                }
              }
            </div>
            <div class="sb-alert-section">
              <h4><i class="fa-solid fa-triangle-exclamation text-amber-500"></i> HM Priority Pending ({{ alertItems().hmPending.length }})</h4>
              @if (alertItems().hmPending.length === 0) {
                <p class="sb-muted">None.</p>
              } @else {
                @for (p of alertItems().hmPending; track p.id) {
                  <div class="sb-alert-row">
                    <span class="sb-dot amber"></span>
                    <span>{{ p.name }} <small>({{ p.dept }})</small></span>
                  </div>
                }
              }
            </div>
            <div class="sb-alert-section">
              <h4><i class="fa-regular fa-clock text-orange-500"></i> Overdue &gt; 60 Days ({{ alertItems().overdue60.length }})</h4>
              @if (alertItems().overdue60.length === 0) {
                <p class="sb-muted">None.</p>
              } @else {
                @for (p of alertItems().overdue60; track p.id) {
                  <div class="sb-alert-row">
                    <span class="sb-dot orange"></span>
                    <span>{{ p.name }} <small>({{ p.dept }})</small></span>
                  </div>
                }
              }
            </div>
          }

          @case ('settings') {
            <div class="sb-settings">
              <div class="sb-setting-row">
                <div>
                  <strong>Profile</strong>
                  <p class="sb-muted">{{ profileUi.displayName(currentUser()) }} — {{ currentUser()?.email }}</p>
                </div>
              </div>
              <div class="sb-setting-row">
                <div>
                  <strong>Role</strong>
                  <p class="sb-muted">{{ profileUi.roleBadge(currentUser()) }}</p>
                </div>
              </div>
              <div class="sb-setting-row clickable" (click)="goToUserManagement()">
                <div>
                  <strong>User Management</strong>
                  <p class="sb-muted">Manage operators and approvers</p>
                </div>
                <i class="fa-solid fa-chevron-right"></i>
              </div>
              <div class="sb-setting-row">
                <div>
                  <strong>Real-time Sync</strong>
                  <p class="sb-muted">Firestore listener active — data updates live.</p>
                </div>
                <span class="sb-pill completed">ACTIVE</span>
              </div>
            </div>
          }

          @case ('help') {
            <div class="sb-help">
              <div class="sb-help-icon"><i class="fa-solid fa-headset"></i></div>
              <h4>Need Assistance?</h4>
              <p>Contact the PPMS support team for help with project data, user access, or technical issues.</p>
              <div class="sb-help-contacts">
                <a href="mailto:support@nimbletech.co.in" class="sb-help-link">
                  <i class="fa-regular fa-envelope"></i> support&#64;nimbletech.co.in
                </a>
                <a href="tel:+911234567890" class="sb-help-link">
                  <i class="fa-solid fa-phone"></i> +91 12345 67890
                </a>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
}